import { Space } from 'antd'
import { useNetwork } from 'ahooks'

import { fasIcons } from '@/assets/FAIcons'
import FAIcon from '@/components/micro/FAIcon'

const CheckNetwork = () => {
	const networkState = useNetwork()
	const { online } = networkState

	if (online) return null

	return (
		<div
			className={`fixed inset-0 z-50 flex h-screen items-center justify-center bg-[--body-bg-color]`}
		>
			<Space direction='vertical' align='center' className='mb-5'>
				<FAIcon
					icon={fasIcons.faWifiExclamation}
					className='anticon !text-[150px] !text-[--danger-color]'
				/>
				<p className='m-0 text-lg font-medium'>You&apos;re not connected to the internet.</p>
			</Space>
		</div>
	)
}

export default CheckNetwork
